import { getUserFacingApiMessage } from "../../../utils/getUserFacingApiMessage";

const CONTEXT_FALLBACKS = {
  createCard: { error: "actionErrorCreateCard", hint: "actionErrorCreateCardHint" },
  saveCard: { error: "actionErrorSaveCard", hint: "actionErrorSaveCardHint" },
  deleteCard: { error: "actionErrorDeleteCard", hint: "actionErrorDeleteCardHint" },
  createColumn: { error: "actionErrorCreateColumn", hint: "actionErrorCreateColumnHint" },
  updateColumn: { error: "actionErrorUpdateColumn", hint: "actionErrorUpdateColumnHint" },
  deleteColumn: { error: "actionErrorDeleteColumn", hint: "actionErrorDeleteColumnHint" },
  moveCard: { error: "actionErrorMoveCard", hint: "actionErrorMoveCardHint" },
  createBoard: { error: "actionErrorCreateBoard", hint: "actionErrorCreateBoardHint" },
  updateBoard: { error: "actionErrorUpdateBoard", hint: "actionErrorUpdateBoardHint" },
  deleteBoard: { error: "actionErrorDeleteBoard", hint: "actionErrorDeleteBoardHint" },
  addMember: { error: "actionErrorAddMember", hint: "actionErrorAddMemberHint" },
  updateMemberRole: { error: "actionErrorUpdateMemberRole", hint: "actionErrorUpdateMemberRoleHint" },
  removeMember: { error: "actionErrorRemoveMember", hint: "actionErrorRemoveMemberHint" },
  checklist: { error: "actionErrorChecklist", hint: "actionErrorChecklistHint" },
  attachment: { error: "actionErrorAttachment", hint: "actionErrorAttachmentHint" },
  upload: { error: "actionErrorUpload", hint: "actionErrorUploadHint" },
  comment: { error: "actionErrorComment", hint: "actionErrorCommentHint" },
  generic: { error: "actionErrorGeneric", hint: "actionErrorGenericHint" },
};

function resolveStatus(err) {
  return err?.status ?? err?.response?.status ?? null;
}

function isNetworkError(err) {
  if (!err) return false;
  const msg = String(err?.message || "").toLowerCase();
  return (
    err?.code === "ERR_NETWORK" ||
    msg.includes("network error") ||
    msg.includes("failed to fetch") ||
    msg.includes("network request failed")
  );
}

function isSchemaError(err) {
  const status = resolveStatus(err);
  const msg = String(err?.message || "").toLowerCase();
  return status === 503 || msg.includes("schema") || msg.includes("indisponível");
}

/**
 * Mensagem + orientação para o usuário final (sem jargão técnico).
 * @param {unknown} err
 * @param {string} context — chave em CONTEXT_FALLBACKS
 * @param {(key: string) => string} t
 */
export function formatTeamTaskFeedback(err, context = "generic", t) {
  const ctx = CONTEXT_FALLBACKS[context] || CONTEXT_FALLBACKS.generic;
  const status = resolveStatus(err);

  if (isNetworkError(err)) {
    return {
      title: t("actionErrorTitle"),
      message: t("actionErrorNetwork"),
      hint: t("actionErrorNetworkHint"),
    };
  }

  if (status === 401) {
    return {
      title: t("actionErrorTitle"),
      message: t("actionErrorUnauthorized"),
      hint: t("actionErrorUnauthorizedHint"),
    };
  }

  if (status === 403) {
    const { action } = getUserFacingApiMessage(err);
    return {
      title: t("actionErrorTitle"),
      message: t("actionErrorForbidden"),
      hint: action || t("actionErrorForbiddenHint"),
    };
  }

  if (isSchemaError(err)) {
    return {
      title: t("actionErrorTitle"),
      message: t("actionErrorSchema"),
      hint: t("actionErrorSchemaHint"),
    };
  }

  const { message: apiMessage, action } = getUserFacingApiMessage(err);
  const genericApi = apiMessage === "Não foi possível concluir a operação.";

  return {
    title: t("actionErrorTitle"),
    message: genericApi ? t(ctx.error) : apiMessage,
    hint: action || t(ctx.hint),
  };
}
